import React from "react";
import { Link } from "react-router-dom";
import "./styles/about.css";

export default function About(){
    

    return(
        <div>
            <div className="one">
                <h1>Who I am?</h1>
                <div className="d1" id="d1">
                    <i className="material-icons">&#63;</i> 
                </div>
                <div className="d2" id="d2">
                        <span>PROBABLY NOT A SUPERHERO 🙃 </span><br/>
                        I am currently in second year of my graduation and I am doing 
                        BE in computer science and Engineering
                </div>
            </div>
            <div className="afoot">
                <Link to="/skills">
                <button className="btn">
                    <span>My Interests</span>
                </button>
                </Link>
            </div>
        </div>
    );
}